module.exports = __webpack_public_path__ + "static/media/feather_coffee.068c31fd.svg";